import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceDept {
    lookupService = new APIServiceLookUp();

    async getAllDept(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}dept/getAllDept`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}